import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attachment",
  "use": "attachment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"attachment\"><path d=\"M12 22.75a6.33 6.33 0 01-5-2c-2.28-2.58-1.8-6.66-1.77-6.83V6C5.25 4.36 6 1.25 9 1.25S12.75 4.36 12.75 6v8a.75.75 0 11-1.5 0V6c0-.13 0-3.25-2.25-3.25S6.75 5.87 6.75 6v8c0 .13-.42 3.69 1.41 5.75a4.86 4.86 0 003.84 1.5 4.859 4.859 0 003.84-1.5c1.83-2.06 1.42-5.62 1.42-5.66V2a.75.75 0 111.5 0v12c0 .08.5 4.16-1.78 6.74A6.331 6.331 0 0112 22.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol